import { render } from "./PricingSuccessful.vue?vue&type=template&id=8a737d12&scoped=true"
import script from "./PricingSuccessful.vue?vue&type=script&lang=js"
export * from "./PricingSuccessful.vue?vue&type=script&lang=js"

import "./PricingSuccessful.vue?vue&type=style&index=0&id=8a737d12&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a737d12"]])

export default __exports__